class FullWidthMediaSlider extends window.BAO.CustomElement() {
  constructor () {
    super();
    this.splide = null;
  }

  connectedCallback () {
    super.connectedCallback();

    window.addEventListener('load', () => {
      this.initializeCarousel();
      this.setupListeners();
    });
  }

  setupListeners () {
  }

  initializeCarousel () {
    this.splide = new Splide(this.els.slider.element, {
      classes: {
        pagination: 'splide__pagination sec-FullWidthMedia_Pagination',
        page: 'splide__pagination__page sec-FullWidthMedia_PaginationDot',
      },
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: true,
      autoplay: this.els.slider.element.getAttribute('data-slider-autoplay') === 'true',
      interval: Number(this.els.slider.element.dataset.sliderAutoplaySpeed) || 2000,
    });
    this.splide.mount();
    this.els.slider.element.setAttribute('data-initialized', 'true');
  }

}

if (!customElements.get('fullwidth-media-slider')) {
  customElements.define('fullwidth-media-slider', FullWidthMediaSlider);
}